import axios from 'axios'
import qs from 'qs'
// 获取cookie、
// function getCookie (name) {
//   let arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
//   let reg = arr
//   if (arr === document.cookie.match(reg)) {
//     return (arr[2])
//   } else {
//     return null
//   }
// }

// 创建axios实例
const service = axios.create({
  // baseURL: config.API_SERVER, // api 的 base_url
  timeout: 600000 // 请求超时时间
})

axios.defaults.withCredentials = true

// request拦截器
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers['x-csrf-token'] = getCookie('csrfToken')
    //   config.headers['X-Access-Token'] = getToken() // 让每个请求携带自定义token
    // }
    if (config.method === 'post') {
        config.data = qs.stringify(config.data)
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }

    return config
  },
  onRejectederror => {
    // Do something with request error
    // console.log(error)  // for debug
    Promise.reject(error)
  }
)

export default service
